import * as React from 'react'

// Components
import Svg from './..'

const Rabbit = props => {
  return (
    <Svg fill='none' viewBox='0 0 14 12' {...props}>
      <path
        d='M5.45 2.835c-2.24 0-3.63 1.497-3.63 3.393 0 .92.737 2.993 5.721 5.363.262.12.682.409 1.718.409h2.408c0-.985-.878-.957-2.8-.995-.01-2.62-.532-4.182-2.268-5.855l-.738.074c2.632 1.208 3.472 2.78 3.472 4.833l2.754-2.063-1.932-2.129c-.579-.78-1.97-3.03-4.704-3.03zm-2.22 7.743c-.505.018-.897.307-.897.957 0 0 1.923.019 3.286-.39l-1.382-.734a3.363 3.363 0 01-1.008.167zm7.643-5.075l.906-.354C11.219 2.798 10.033 1.042 8.297 0c0 1.72.878 3.588 2.576 5.503zM12.217 0c-.756 1.46-.756 3.16 0 4.517.738-1.357.738-3.058 0-4.517zM9.455 6.516l2.632 1.487c.886 0 1.913-.111 1.913-.8 0-1.105-1.652-2.444-2.856-2.054zM0 6.469c0 1.897 2.93 1.897 2.93 0 0-1.821-2.93-1.821-2.93 0z'
        fill='#3ce967'
      />
    </Svg>
  )
}

export default Rabbit
